import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../../types';

import { ImageRoundedStyled } from './ImageRounded.styled';

const ImageRounded = ({ picture, modifiers }) => (
  <ImageRoundedStyled modifiers={modifiers}>
    <img src={picture} alt="Content" />
  </ImageRoundedStyled>
);

export default ImageRounded;

ImageRounded.propTypes = {
  picture: PropTypes.string,
  modifiers: CustomTypes.oneOrMore([
    '',
    'small',
    'medium',
    'large',
    'xLarge',
    'wBorder',
  ]),
};

ImageRounded.defaultProps = {
  picture: '',
  modifiers: '',
};
